import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import sheetImportSlices, { type SheetImportSlices } from './slices';

const devtoolsInstance = devtools(sheetImportSlices, {
  name: 'useSheetImportStore',
});

const useSheetImportStore = create<SheetImportSlices, [['zustand/devtools', never]]>(devtoolsInstance);

export default useSheetImportStore;
